module.exports = __webpack_public_path__ + "img/77425b8a79f0ddc35ec5edb44422421d.bbb1785c.png";